import { BaseCreate } from '@/components/create';
import useLayout from '@/hooks/useLayout';
import { useOrder } from '@/modules/order/application/order';
import { useSnackbar } from '@rrexpress/core';
import { useNavigation } from '@refinedev/core';
import { OrderForm } from './form';

export function OrderCreatePage() {
  const { calculateParcelPrice, createOrder, loadingCreate } = useOrder();
  const { list } = useNavigation();
  const { show } = useSnackbar();
  useLayout({
    title: 'Order',
  });

  const handleOnCreateOrder = async (values: IOrderCreatePayload) => {
    try {
      await createOrder(values);
      list('orders');
      show('Berhasil membuat order', 'success');
    } catch (error: any) {
      show(error?.message, 'error');
    }
  };

  return (
    <BaseCreate
      title="Buat Order Baru"
      isLoading={loadingCreate}
    >
      <OrderForm
        onSubmit={(values) => handleOnCreateOrder(values)}
      />
    </BaseCreate>
  );
}

export default OrderCreatePage;
